module.exports = __webpack_public_path__ + "img/report_header.0ef1337a.png";